module.exports = {
          srcSet: __webpack_public_path__ + "public/6c7abc3c7b352040ad7b24775e2b17c2-57.png"+" 57w",
          images:[ {path: __webpack_public_path__ + "public/6c7abc3c7b352040ad7b24775e2b17c2-57.png",width: 57,height: 56}],
          src: __webpack_public_path__ + "public/6c7abc3c7b352040ad7b24775e2b17c2-57.png",
          toString:function(){return __webpack_public_path__ + "public/6c7abc3c7b352040ad7b24775e2b17c2-57.png"},
          
          width: 57,
          height: 56
        }